<template>
  <div class="picto-container needResize">
    <div class="picto-item" v-for="(picto, index) in pictos" :key="index">
      <Picto :color="picto.color" :name="picto.name" :number="picto.number" :legend="picto.legend" :currency="picto.currency"></Picto>
    </div>
  </div>
</template>

<script>
  import Picto from './Picto.vue'
  import currency from '../currency.js'
  import moment from 'moment'

  export default {
    name: 'PictoContainer',
    props: {
      result: Object, 
      search: Object
    },
    components: {
      Picto
    },
    data() {
      return { 
      }
    },
    watch: {
      result() {
        this.refresh()
      }
    },
    computed: {
      totalHt() {
        if (!this.result || !this.result.aggregations || !this.result.aggregations["to-bills"] || !this.result.aggregations["to-bills"].bills) return 0

        const bills = this.result.aggregations["to-bills"].bills;
        const totalSalesHt = (bills.details && bills.details['filtered-results'] && bills.details['filtered-results'].totalProductPriceHt) ?
          bills.details['filtered-results'].totalProductPriceHt.value :
          bills.total_sales_ht.value

        return parseInt(Math.round(totalSalesHt / 1000)).toLocaleString()
      },

      totalTtc() {
        if (!this.result || !this.result.aggregations || !this.result.aggregations["to-bills"] || !this.result.aggregations["to-bills"].bills) return "0"
        const bills = this.result.aggregations["to-bills"].bills;
        if (this.search.query.mode === "details") {
          const totalSalesTtc = (bills.details && bills.details['filtered-results'] && bills.details['filtered-results'].totalAmountPostDiscountTtc) ?
            bills.details['filtered-results'].totalAmountPostDiscountTtc.value :
            bills.total_sales.value
          return parseInt(Math.round(totalSalesTtc / 1000)).toLocaleString()
        }else{
          return parseInt(Math.round(bills.total_sales.value / 1000)).toLocaleString()
        }
      },

      pictos: function() {
        let vehicleAge = 0
          // , profitPercent = 0
          , freq = 0
          , profitValue = '0'
          , meanBasket = '0'
          , cumulBasket = 0
          , totalDiscount = 0
          , discountRowsPercent = 0
          , caExTax = this.totalHt
          , caIncTax = this.totalTtc
          , meanAge = 0
          , meanCustomerAge = 0
          , infoAge = ''
          , infoCustomerAge = ''
          , percentageCA = 0
          , percentageQuantity = 0
          , seniority = 0
        if (this.result && this.result.aggregations && this.result.aggregations["to-bills"] && this.result.aggregations["to-bills"].bills) {
          let bills = this.result.aggregations["to-bills"].bills;
          vehicleAge = bills.vehicles.age.value ? bills.vehicles.age.value.toFixed(1) : '0'

          let hits = this.result.hits ? this.result.hits.total : 0
          let totalSales = bills.total_sales.value

          let nb_bills = bills.doc_count
          freq = nb_bills && hits ? (nb_bills / hits).toFixed(2) : '0'

          if (this.search.query.mode === "details" && bills.details && bills.details['filtered-results'] && bills.details['filtered-results'].meanBasket && bills.details['filtered-results'].meanBasket.value) {
            meanBasket = bills.details['filtered-results'].meanBasket.value.toFixed(2)
          } else {
            meanBasket = bills.meanBasket && bills.meanBasket.value ? bills.meanBasket.value.toFixed(2) : '0'
          }

          if (this.search.query.mode === "details" && bills.details && bills.details['filtered-results'] && bills.details['filtered-results'].totalProfBrandHt && bills.details['filtered-results'].totalProfBrandHt.value) {
            profitValue = (bills.details['filtered-results'].totalProfBrandHt.value / 1000).toFixed(0)
          } else {
            let profBrandHt = bills.prof_brand_ht && bills.prof_brand_ht.value ? (bills.prof_brand_ht.value / 1000).toFixed(0) : 0
            profitValue = parseInt(profBrandHt).toLocaleString()
          }

          cumulBasket = totalSales && hits ? (totalSales / hits).toFixed(2) : '0'

          let nbDiscountBuckets = bills.nb_bills_with_discount ? bills.nb_bills_with_discount.buckets : [];
          let discounted = nbDiscountBuckets ? nbDiscountBuckets.find(element => element.key === 1) : null;
          let discountBillsNumber = discounted && discounted.hasOwnProperty('doc_count') ? discounted.doc_count : 0


          let totalDiscountTtc = (bills.details && bills.details['filtered-results'] && bills.details['filtered-results'].total_discount_ttc) ? bills.details['filtered-results'].total_discount_ttc.value : 0;
          totalDiscount = Math.round(Math.abs(totalDiscountTtc ? totalDiscountTtc.toFixed(2) : '0') / 1000).toLocaleString()

          discountRowsPercent = nb_bills ? (parseFloat(discountBillsNumber) * 100.0 / parseFloat(nb_bills)).toFixed(2) : '0'

          /** age du client au moment du ticket => moyenne sur tous les tickets**/
          meanAge = (bills.customerAges && bills.customerAges.age && bills.customerAges.age.value) ? bills.customerAges.age.value.toFixed(1) : '0'
          let ageNumber = (bills.customerAges && bills.customerAges.doc_count) ? bills.customerAges.doc_count : 0
          let agePercent = nb_bills ? Math.round(ageNumber *100 *100 / nb_bills) /100 : 0

          /** age du client maintenant => Moyenne des clients **/
          meanCustomerAge = (this.result.aggregations.ages && this.result.aggregations.ages.age && this.result.aggregations.ages.age.value) ? this.result.aggregations.ages.age.value.toFixed(1) : '0'
          let customerAgeNumber = this.result.aggregations.ages ? (this.result.aggregations.ages.doc_count || 0) : 0
          let customerAgePercent = (this.result.aggregations.nb_customers && this.result.aggregations.nb_customers.value) ? Math.round(ageNumber *100 *100 / this.result.aggregations.nb_customers.value) /100 : 0

          infoAge = this.$t("pictoContainer.concernedTickets") + " : " + ageNumber.toLocaleString() + " (" + agePercent + "%)"
          infoCustomerAge = this.$t("pictoContainer.concernedClients") + " : " + customerAgeNumber.toLocaleString() + " (" + customerAgePercent + "%)"
          seniority = (bills.seniority && bills.seniority.value) ? parseInt(bills.seniority.value.toFixed(0)).toLocaleString() : 0
        }
        let result = [
          {
            color: "#56D9FE",
            number: `${vehicleAge} ${this.$t('pictoContainer.averageVehicleAgeUnit')}`,
            legend: this.$t("pictoContainer.averageVehicleAgeLegend"),
            name: "calendar",
            currency: null,
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          /*{
            color: "#FEC163",
            number: `${profitPercent} %`,
            legend: "De marge",
            name: "curve-arrow"
          },*/
          {
            color: "#A3A0FB",
            number:  `${meanAge} ${this.$t('pictoContainer.averageCustomerAgeUnit')}`,
            legend: this.$t("pictoContainer.averageCustomerAgeLegend"),
            name: "client",
            currency: infoAge, // not really a currency value, but wathever we want to use the same css as the one used for this
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          {
            color: "#A3A0FB",
            number:  `${meanCustomerAge} ${this.$t('pictoContainer.averageCustomerAgeUnit')}`,
            legend: this.$t("pictoContainer.averageCustomerAgeNowLegend"),
            name: "client",
            currency: infoCustomerAge, // not really a currency value, but wathever we want to use the same css as the one used for this
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          {
            color: "#FF6565",
            number: `${freq} ${this.$t('pictoContainer.frequencyPerYearUnit')}`,
            legend: this.$t("pictoContainer.frequencyPerYearLegend"),
            name: "chrono",
            currency: null,
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          {
            color: "#000000",
            number: `${profitValue} k${this.getCurrencyLabel()}`,
            legend: this.$t("pictoContainer.marginLegend"),
            name: "stats",
            currency: `${this.getEuroVal(profitValue, true)}`,
            display: ["profile", "ticket", "details"].includes(this.search.query.mode) && !this.$store.state.user.brands
          },
          {
            color: "#5EE2A0",
            number: `${meanBasket} ${this.getCurrencyLabel()}`,
            legend: this.search.query.mode === "details" ? this.$t("pictoContainer.averageCartLegend") : this.$t("pictoContainer.averagePrice"),
            name: "cart",
            currency: `${this.getEuroVal(meanBasket, false)}`,
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          {
            color: "#5EE2A0",
            number: `${cumulBasket} ${this.getCurrencyLabel()}`,
            legend: this.$t("pictoContainer.expensesPerClientLegend"),
            name: "cart",
            currency: `${this.getEuroVal(cumulBasket, false)}`,
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          {
            color: "#56D9FE",
            number: `${caExTax} k${this.getCurrencyLabel()}`,
            legend: this.$t("ca.legendWithoutTaxes"),
            name: "coin",
            currency: `${this.getEuroVal(caExTax, true)}`,
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          {
            color: "#56D9FE",
            number: `${caIncTax} k${this.getCurrencyLabel()}`,
            legend: this.$t("ca.legendWithTaxes"),
            name: "coin",
            currency: `${this.getEuroVal(caIncTax, true)}`,
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          {
            color: "#FF6565",
            number: `${totalDiscount} k${this.getCurrencyLabel()}`,
            legend: this.$t("pictoContainer.totalDiscountLegend"),
            name: "discount",
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          {
            color: "#FF6565",
            number: `${discountRowsPercent} %`,
            legend: this.$t("pictoContainer.discountRowsPercentLegend"),
            name: "discount",
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          },
          {
            color: "#FF6565",
            number: `${seniority} `,
            legend: this.$t("pictoContainer.seniority"),
            name: "chrono",
            currency: `${this.getEuroVal(cumulBasket, false)}`,
            display: ["profile", "ticket", "details"].includes(this.search.query.mode)
          }
        ]

        //si c'est un details, on veut cacher la marge et le CA HT
        //également changer la légende pour le panier moyen
        if (this.search.query.mode === "details") {
          //
        } else if (this.$store.state.user.brands) {
          result.splice(3, 1)
        }
        return result
      }
    },
    methods: {
      getCurrencyLabel() {
        let bu = this.search.query.businessUnit
        return currency.currency(bu)
      },
      getEuroVal(valueToConvert, isKVal) {
        let bu = this.search.query.businessUnit,
        currencyLabel = this.getCurrencyLabel(),
        currencies = this.$store.state.currencies.currenciesValues,
        date = this.$store.state.currencies.date
        
        if(currencies === null || currencyLabel === '€') {
          return ''
        }
        if(this.$i18n.locale === 'fr') {
          date = moment(String(date)).format('DD/MM/YYYY')
        }
        let euroValue = currency.getEuroValue(currencies, bu, valueToConvert)
        let euro = ' € '
        if(isKVal) {
          euro = ' k€ '
        }
        return euroValue + euro + this.$t("pictoContainer.datePrefix") + ' ' + date
      }, 
      refresh() {
        this.$forceUpdate()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/styles/components/picto_container.sass"
</style>
